<template>
  <div class="container">
    <div class="panel">
      <div class="info">
        <div class="info-item-1">
          {{ $t('xiaoshililunchannenggongshi') }}
        </div>
        <div class="info-item-2">
          {{ $t('dangbanlilunchannenggongshi') }}
        </div>
        <div class="info-item-3">
          {{ $t('dangbanwanchenglvgongshi') }}
        </div>
      </div>
    </div>
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/meilida/dailyReport/page" getKey="rows" :columns="columns" :isShowChildSelection="false">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('riqi')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startDate" :end.sync="yt.conditions.endDate"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('banci')">
            <el-select v-model="yt.conditions.shiftId" :placeholder="$t('qingxuanze')" clearable filterable>
              <el-option v-for="item in shiftList" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao')">
            <el-input v-model="yt.conditions.mouldNo" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="onSearch" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ startDate: begin(), endDate: end() })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 当班完成率 自定义单元格颜色 -->
      <template #dangbanwanchenglv="scope">
        <span v-if="scope.row.completionColor === 'green'" class="completion-cell completion-green">
          {{ scope.row.completionRate != null ? scope.row.completionRate + '%' : '-' }}
        </span>
        <span v-else-if="scope.row.completionColor === 'orange'" class="completion-cell completion-orange">
          {{ scope.row.completionRate != null ? scope.row.completionRate + '%' : '-' }}
        </span>
        <span v-else-if="scope.row.completionColor === 'red'" class="completion-cell completion-red">
          {{ scope.row.completionRate != null ? scope.row.completionRate + '%' : '-' }}
        </span>
        <span v-else class="completion-cell completion-gray">
          {{ scope.row.completionRate != null ? scope.row.completionRate + '%' : 'N/A' }}
        </span>
      </template>
      <!-- 生产进度 自定义渲染 -->
      <template #shengchanjindu="scope">
        <span v-if="scope.row.progressRate != null">
          {{ scope.row.progressRate }}%
        </span>
        <span v-else>-</span>
      </template>
      <!-- 估算 自定义渲染 -->
      <template #gusuan="scope">
        <el-tag v-if="scope.row.estimated === 1" size="mini" type="warning">{{ $t('shi') }}</el-tag>
        <el-tag v-else size="mini" type="info">{{ $t('fou') }}</el-tag>
      </template>
    </yi_curd_table>

    <!-- 异常条目提示横幅 -->
    <div v-if="anomalyList.length > 0" class="anomaly-banner">
      <i class="el-icon-warning icon"></i>
      <div class="text">
        异常提示：<span class="count">{{ anomalyList.length }}</span>条
        <span class="wo-list">{{ anomalyWoNoList }}</span>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';
export default {
  name: 'web_customize_meilida_report_injection_daily_report_list',
  data() {
    return {
      exportLoading: false,
      anomalyList: [],
      shiftList: [],
      columns: [
        { label: 'shebeimingcheng', prop: 'equipmentName', width: 120 },
        { label: 'shengchangongdanhao', prop: 'woNo', width: 140 },
        { label: 'chanpinbianma', prop: 'materialCode', width: 140 },
        { label: 'chanpinmingcheng', prop: 'materialName', width: 160 },
        { label: 'mujubianhao', prop: 'mouldNo', width: 130 },
        { label: 'baogongbanci', prop: 'shiftName', width: 100 },
        { label: 'baogongriqi', prop: 'reportDate', format: "YYYY-MM-DD", type: 'time', width: 110 },
        { label: 'jihuashuliang', prop: 'planQuantity',  width: 100 },
        { label: 'biaozhunzhouqi(miao/mu)', prop: 'standardCycle', width: 130 },
        { label: 'muxueshu', prop: 'cavity', width: 90 },
        { label: 'xiaoshililunchanneng', prop: 'hourlyCapacity', width: 120 },
        { label: 'dangbanlilunchanneng', prop: 'shiftCapacity', width: 120 },
        { label: 'dangbanshengchanshuliang', prop: 'quantity', width: 120 },
        { label: 'dangbanwanchenglv', prop: 'completionRate', width: 110, type: 'slot' },
        { label: 'leijiwancheng', prop: 'cumulativeQuantity', width: 110 },
        { label: 'shengchanjindu', prop: 'progressRate', width: 110, type: 'slot' },
        { label: 'yunxingshichang(h)', prop: 'runHours', width: 120 },
        // { label: 'dangbanbuliangshuliang', prop: 'badQuantity', width: 120 },
        // { label: 'jiqijilushuliang', prop: 'machineQuantity', width: 120 },
        // { label: 'chayishuliang', prop: 'diffQuantity', width: 110 },
        { label: 'gusuan', prop: 'estimated', width: 80, type: 'slot' },
        { label: 'beizhu', prop: 'remark', width: 160 }
      ]
    };
  },
  computed: {
    anomalyWoNoList() {
      if (!this.anomalyList || this.anomalyList.length === 0) {
        return '';
      }
      let woNos = this.anomalyList.map(item => item.woNo).filter(woNo => woNo);
      let unique = [...new Set(woNos)];
      if (unique.length === 0) {
        return '';
      }
      let display = unique.slice(0, 5).join('、');
      if (unique.length > 5) {
        display += ` 等 ${unique.length} 项`;
      }
      return display;
    }
  },
  watch: {
    dateRange: {
      handler(newVal) {
        if (!this.yt || !this.yt.conditions) {
          return;
        }
        if (newVal && newVal.length === 2) {
          this.yt.conditions.startDate = newVal[0];
          this.yt.conditions.endDate = newVal[1];
        } else {
          this.yt.conditions.startDate = null;
          this.yt.conditions.endDate = null;
        }
      },
      immediate: true
    }
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt.conditions, 'startDate', this.begin());
      this.$set(this.yt.conditions, 'endDate', this.end());
      this.yt.get(1);
      this.fetchAnomaly();
      this.fetchShiftList();
    }, 300);
  },
  methods: {
    fetchShiftList() {
      return this.http
        .get('/web/setting/shift/getShiftByCustomer')
        .then(response => {
          this.shiftList = response.data || [];
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    fetchAnomaly() {
      let params = this.buildQueryParams();
      return this.http
        .get('/custom/meilida/dailyReport/anomaly?' + this.qs.stringify(params))
        .then(response => {
          this.anomalyList = response.data || [];
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    buildQueryParams() {
      let conds = this.yt.conditions || {};
      let params = {
        startDate: conds.startDate,
        endDate: conds.endDate
      };
      if (conds.shiftId) {
        params.shiftId = conds.shiftId;
      }
      if (conds.equipmentIds && (Array.isArray(conds.equipmentIds) ? conds.equipmentIds.length > 0 : conds.equipmentIds)) {
        params.equipmentIds = conds.equipmentIds;
      }
      if (conds.woNo) {
        params.woNo = conds.woNo;
      }
      if (conds.materialId) {
        params.materialId = conds.materialId;
      }
      if (conds.mouldNo) {
        params.mouldNo = conds.mouldNo;
      }
      return params;
    },
    onSearch() {
      this.yt.get(1);
      this.fetchAnomaly();
    },
    begin() {
      let date = new Date();
      let begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      let date = new Date();
      let end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
      return end;
    },
    exportExcel() {
      this.exportLoading = true;
      // 查询全量数据用于导出
      this.http.get('/custom/meilida/dailyReport/page?pageNum=1&pageSize=999999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => this.$t(i.label));
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows || [];
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i], tableFirst);
          tableData.push(dataArr);
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `注塑车间单班产能监控_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    getTableDataArr(row, tableFirst) {
      let dataArr = [];
      let colProps = this.columns.map(i => i.prop);
      for (let j = 0; j < colProps.length; j++) {
        let prop = colProps[j];
        let val = row[prop];
        if (prop === 'reportDate' && val) {
          val = this.dayjs(val).format('YYYY-MM-DD');
        } else if (prop === 'completionRate') {
          val = val != null ? val + '%' : 'N/A';
        } else if (prop === 'progressRate') {
          val = val != null ? val + '%' : '-';
        } else if (prop === 'estimated') {
          val = val === 1 ? '是' : '否';
        } else if (prop === 'hourlyCapacity' || prop === 'shiftCapacity' || prop === 'runHours') {
          val = val != null ? val : '-';
        }
        dataArr[j] = val != null ? String(val) : '';
      }
      return dataArr;
    },
  }
};
</script>
<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  height: 100%;
  min-width: 500px;

  .panel {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin: 0 0 10px 20px;
    background: #f7f8fa;
    color: #909399;
    height: 28px;
    line-height: 28px;
    // min-width: 1000px;
    width: 100%;
    flex-shrink: 0;

    // 效率信息说明
    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      background: #f7f8fa;
      color: #909399;
      height: 28px;
      line-height: 28px;
      // min-width: 1000px;
      width: 100%;
      flex-shrink: 0;

      .info-item-1 {
        width: 33%;
        max-width: 300px;
        min-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-2 {
        width: 33%;
        max-width: 350px;
        min-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-3 {
        //text-align: center;
        width: 33%;
      }
    }
  }

  .anomaly-banner {
    background: #fdf6ec;
    border: 1px solid #f5dab1;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 8px 0;
    display: flex;
    align-items: center;

    .icon {
      color: #e6a23c;
      font-size: 16px;
      margin-right: 8px;
    }

    .text {
      color: #606266;
      font-size: 13px;
      flex: 1;
    }

    .count {
      color: #e6a23c;
      font-weight: bold;
      margin: 0 4px;
    }

    .wo-list {
      color: #909399;
      margin-left: 8px;
    }
  }

  .completion-cell {
    padding: 2px 6px;
    border-radius: 3px;
    display: inline-block;
    min-width: 60px;
    text-align: center;
    color: #fff;
    font-size: 12px;
  }

  .completion-green {
    background: #67c23a;
  }

  .completion-orange {
    background: #e6a23c;
  }

  .completion-red {
    background: #f56c6c;
  }

  .completion-gray {
    background: #909399;
  }
}
</style>